"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "meter",
    path: "/meters/:id",
    component: "Meter",
    params: [{
            name: "id",
            prop: "meterId",
        },
    ]
});
let Meter = class Meter extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    meterId;
    onMeter_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("meterId");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    tabManager;
    async $$load_tabManager() {
        return new this.$app.utils.LazyTabManager();
    }
    item;
    async $$load_item() {
        return this.$fn.fetch('read_meter', { asResource: true, parameters: { id: this.meterId } });
    }
    ux;
    b_7315092382398562_modalBindings;
    b_2285343489561581_to;
    dataMembers = ['tabManager', 'item', 'ux', 'b_7315092382398562_modalBindings', 'b_2285343489561581_to'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                tabManager: null,
                item: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "sm",
                },
                b_2285343489561581_to: {
                    name: "app.meters",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: [this.item.snapshot('serial_number'),
                    this.$fn.gettext("Meter"),
                ],
                icon: this.item ? this.$config.meterTypes[this.item.meter_type].icon : this.$config.meter.icon,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_4910_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2095089031469157_clickPreventStop(event, scope) {
        return await this.actions.evh_2095089031469157_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async evh_9004123373732307_success(event, scope) {
        return await this.actions.evh_9004123373732307_success.executeFromDOM(this, event, scope);
    }
    async act_397195341670858_showModal_4916_getActionArgs($event) {
        return {
            name: "entityEvents",
            props: {
                entityId: this.item.id,
            },
        };
    }
    async evh_397195341670858_clickPreventStop(event, scope) {
        return await this.actions.evh_397195341670858_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async evh_2679161326024595_reload(event, scope) {
        return await this.actions.evh_2679161326024595_reload.executeFromDOM(this, event, scope);
    }
    async act_2679161326024595_setData_4920_getActionArgs($event) {
        return {
            path: "item",
            value: $event.data,
            resolve: false,
            noTouchLastLoaded: true,
            noTakeSnapshot: false,
        };
    }
    async evh_2679161326024595_saved(event, scope) {
        return await this.actions.evh_2679161326024595_saved.executeFromDOM(this, event, scope);
    }
    async evh_7987652045662005_reload(event, scope) {
        return await this.actions.evh_7987652045662005_reload.executeFromDOM(this, event, scope);
    }
    async evh_6806515264385235_reload(event, scope) {
        return await this.actions.evh_6806515264385235_reload.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_4910 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_4910_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_4909 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_4910,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_4909],
        });
        const act_2095089031469157_reloadComponentData_4912 = new core_1.actions.ReloadComponentDataAction({
            displayName: "reload",
            events: [],
        });
        const evh_2095089031469157_clickPreventStop_4911 = new core_1.actions.EventHandlerImpl({
            action: act_2095089031469157_reloadComponentData_4912,
            event: "click.prevent.stop",
            displayName: "reload",
        });
        const evh_2095089031469157_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2095089031469157_clickPreventStop_4911],
        });
        const act_9004123373732307_closeComponent_4914 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_9004123373732307_success_4913 = new core_1.actions.EventHandlerImpl({
            action: act_9004123373732307_closeComponent_4914,
            event: "success",
            displayName: "closeComponent",
        });
        const evh_9004123373732307_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_9004123373732307_success_4913],
        });
        const act_397195341670858_showModal_4916 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_397195341670858_showModal_4916_getActionArgs,
            events: [],
        });
        const evh_397195341670858_clickPreventStop_4915 = new core_1.actions.EventHandlerImpl({
            action: act_397195341670858_showModal_4916,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_397195341670858_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_397195341670858_clickPreventStop_4915],
        });
        const act_2679161326024595_reloadComponentData_4918 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_2679161326024595_reload_4917 = new core_1.actions.EventHandlerImpl({
            action: act_2679161326024595_reloadComponentData_4918,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_2679161326024595_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2679161326024595_reload_4917],
        });
        const act_2679161326024595_setData_4920 = new core_1.actions.SetDataAction({
            actionArgs: this.act_2679161326024595_setData_4920_getActionArgs,
            events: [],
        });
        const evh_2679161326024595_saved_4919 = new core_1.actions.EventHandlerImpl({
            action: act_2679161326024595_setData_4920,
            event: "saved",
            displayName: "setData",
        });
        const evh_2679161326024595_saved = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2679161326024595_saved_4919],
        });
        const act_7987652045662005_reloadComponentData_4922 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7987652045662005_reload_4921 = new core_1.actions.EventHandlerImpl({
            action: act_7987652045662005_reloadComponentData_4922,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7987652045662005_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7987652045662005_reload_4921],
        });
        const act_6806515264385235_reloadComponentData_4924 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_6806515264385235_reload_4923 = new core_1.actions.EventHandlerImpl({
            action: act_6806515264385235_reloadComponentData_4924,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_6806515264385235_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6806515264385235_reload_4923],
        });
        return {
            act_7315092382398562_closeModal_4910,
            evh_7315092382398562_close_4909,
            evh_7315092382398562_close,
            act_2095089031469157_reloadComponentData_4912,
            evh_2095089031469157_clickPreventStop_4911,
            evh_2095089031469157_clickPreventStop,
            act_9004123373732307_closeComponent_4914,
            evh_9004123373732307_success_4913,
            evh_9004123373732307_success,
            act_397195341670858_showModal_4916,
            evh_397195341670858_clickPreventStop_4915,
            evh_397195341670858_clickPreventStop,
            act_2679161326024595_reloadComponentData_4918,
            evh_2679161326024595_reload_4917,
            evh_2679161326024595_reload,
            act_2679161326024595_setData_4920,
            evh_2679161326024595_saved_4919,
            evh_2679161326024595_saved,
            act_7987652045662005_reloadComponentData_4922,
            evh_7987652045662005_reload_4921,
            evh_7987652045662005_reload,
            act_6806515264385235_reloadComponentData_4924,
            evh_6806515264385235_reload_4923,
            evh_6806515264385235_reload,
            reload: act_2095089031469157_reloadComponentData_4912,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], Meter.prototype, "meterId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('meterId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Meter.prototype, "onMeter_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], Meter.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Meter.prototype, "onSize", null);
Meter = __decorate([
    (0, vue_property_decorator_1.Component)()
], Meter);
exports.default = Meter;
vue_property_decorator_1.Vue.component("Meter", Meter);
